import {ApiService} from "./ApiService";
import Food from "../models/calculoVET/food";

export const CalculoVETService = {
  searchItem: (query: string) => {
    return ApiService.get<any[]>("/ketnutri/searchItem?query=" + encodeURIComponent(query))
  }
}
